import { Reducer } from 'redux';
import { reducer as simpleFormReducer, INITIAL_SIMPLEFORM_STATE } from 'app/infrastructure/simple-form/reducers';
import { STATE } from 'app/constants';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { withOptionsReducer } from 'app/components/options-handler';
import { AccessItem } from 'app/components/access-panel/shared/types';
import {
  ACTION, ClearUserData, RequestLoadUser, ReceiveLoadUser, FailLoadUser,
  RequestLoadUserAccess, ReceiveLoadUserAccess, FailLoadUserAccess,
  RequestAddUser, RequestUpdateUser, ReceiveAddUser, ReceiveUpdateUser, FailUserExecute,
  RequestChangePersonId, ReceiveChangePersonId, FailChangePersonId,
  RequestExtraInfo, ReceiveExtraInfo, FailExtraInfo,
  RequestPersonOptions, ReceivePersonOptions, FailPersonOptions,
  RequestRole, ReceiveRole, FailRole, UpdateAccessData,
  RequestRolePanelAccess, ReceiveRolePanelAccess, FailRolePanelAccess,
  RequestChangeDatabaseAccount, ReceiveChangeDatabaseAccount, FailChangeDatabaseAccount,
  ProcessUserFailed, ClearValidation,
  RequestDefaultRole, ReceiveDefaultRole, FailDefaultRole, ShowTechnicalUserWarning, HideTechnicalUserWarning,
  RequestCheckRoles, ReceiveCheckRoles, FailCheckRoles,
  UpdateMergeUser,RequestUserOptions,ReceiveUserOptions, FailUserOptions, UpdateValidation,
  ResetValidation, RequestUserItemDelete, ReceiveUserItemDelete, FailUserItemDelete
} from './action-types';
import { AdministrationUserEditState } from './types-store';
import { clearValidation } from 'app/components/access-panel/validation/validation-messages';

export const INITIAL_ADMINISTRATION_STATE: AdministrationUserEditState = {
  data: undefined,
  accessPerson: undefined,
  role: undefined,
  accessData: {},
  validation: {},
  extraInfoCodes: {
    fetching: false,
    values: []
  },
  personOptionsCodes: {
    fetching: false,
    values: []
  },
  rolePanelAccess: false,
  defaultRole: undefined,
  allowedAccessBasedRoles: [],
  fetchingLoadUser: false,
  fetchingSaveUser: false,
  fetchingDatabaseAccount: false,
  fetchingChangePersonId: false,
  fetchingDefaultRole: false,
  isTechnicalUserWarningShown: false,
  hasRoles: false,
  fetchingRoles: false,
  mergeUser: undefined,
  ...INITIAL_SIMPLEFORM_STATE
};

export const reducers: { [indexer: string]: Reducer<AdministrationUserEditState> } = {

  [ACTION.CLEAR_USER_DATA]: (state: AdministrationUserEditState, action: ClearUserData): AdministrationUserEditState => {
    return { ...state, ...INITIAL_ADMINISTRATION_STATE };
  },

  [ACTION.REQUEST_LOAD_USER]: (state: AdministrationUserEditState, action: RequestLoadUser): AdministrationUserEditState => {
    return {
      ...state,
      fetchingLoadUser: true,
      data: undefined
    };
  },

  [ACTION.RECEIVE_LOAD_USER]: (state: AdministrationUserEditState, action: ReceiveLoadUser): AdministrationUserEditState => {
    const { language, location, unit, mainUserGroup, currentUserGroup, userType, accessRole, ...restUserInfo } = action.data as any;
    return {
      ...state,
      fetchingLoadUser: false,
      data: {
        language: codeItemToStoreValue(language),
        location: codeItemToStoreValue(location),
        unit: codeItemToStoreValue(unit),
        mainUserGroup: codeItemToStoreValue(mainUserGroup),
        currentUserGroup: codeItemToStoreValue(currentUserGroup),
        userType: codeItemToStoreValue(userType),
        accessRole: codeItemToStoreValue(accessRole),
        ...restUserInfo
      }
    };

  },

  [ACTION.FAIL_LOAD_USER]: (state: AdministrationUserEditState, action: FailLoadUser): AdministrationUserEditState => {
    return {
      ...state,
      fetchingLoadUser: false
    };
  },

  [ACTION.REQUEST_LOAD_USER_ACCESS]: (state: AdministrationUserEditState, action: RequestLoadUserAccess): AdministrationUserEditState => {
    return state;
  },

  [ACTION.RECEIVE_LOAD_USER_ACCESS]: (state: AdministrationUserEditState, action: ReceiveLoadUserAccess): AdministrationUserEditState => {
    return {
      ...state,
      accessPerson: action.accessPerson
    };
  },

  [ACTION.FAIL_LOAD_USER_ACCESS]: (state: AdministrationUserEditState, action: FailLoadUserAccess): AdministrationUserEditState => {
    return state;
  },

  [ACTION.REQUEST_ADD_USER]: (state: AdministrationUserEditState, action: RequestAddUser): AdministrationUserEditState => {
    return {
      ...state,
      fetchingSaveUser: true
    };
  },

  [ACTION.REQUEST_UPDATE_USER]: (state: AdministrationUserEditState, action: RequestUpdateUser): AdministrationUserEditState => {
    return {
      ...state,
      fetchingSaveUser: true
    };
  },

  [ACTION.RECEIVE_ADD_USER]: (state: AdministrationUserEditState, action: ReceiveAddUser): AdministrationUserEditState => {
    return {
      ...state,
      fetchingSaveUser: false
    };
  },

  [ACTION.RECEIVE_UPDATE_USER]: (state: AdministrationUserEditState, action: ReceiveUpdateUser): AdministrationUserEditState => {
    return {
      ...state,
      fetchingSaveUser: false
    };
  },

  [ACTION.FAIL_USER_EXECUTE]: (state: AdministrationUserEditState, action: FailUserExecute): AdministrationUserEditState => {
    return {
      ...state,
      fetchingSaveUser: false
    };
  },

  [ACTION.REQUEST_CHANGE_USER_ID]: (state: AdministrationUserEditState, action: RequestChangePersonId): AdministrationUserEditState => {

    return {
      ...state,
      fetchingChangePersonId: true
    };
  },

  [ACTION.RECEIVE_CHANGE_USER_ID]: (state: AdministrationUserEditState, action: ReceiveChangePersonId): AdministrationUserEditState => {

    return {
      ...state,
      fetchingChangePersonId: false,
      ...(state.data ? {
        data: {
          ...state.data,
          personId: action.personId
        }
      } : {})
    };
  },

  [ACTION.FAIL_CHANGE_USER_ID]: (state: AdministrationUserEditState, action: FailChangePersonId): AdministrationUserEditState => {

    return {
      ...state,
      fetchingChangePersonId: false
    };
  },

  [ACTION.REQUEST_EXTRA_INFO]: (state: AdministrationUserEditState, action: RequestExtraInfo): AdministrationUserEditState => {
    return {
      ...state,
      extraInfoCodes: {
        fetching: true,
        values: []
      }
    };
  },

  [ACTION.RECEIVE_EXTRA_INFO]: (state: AdministrationUserEditState, action: ReceiveExtraInfo): AdministrationUserEditState => {
    return {
      ...state,
      extraInfoCodes: {
        fetching: false,
        values: action.values
      }
    };
  },

  [ACTION.FAIL_EXTRA_INFO]: (state: AdministrationUserEditState, action: FailExtraInfo): AdministrationUserEditState => {
    return {
      ...state,
      extraInfoCodes: {
        fetching: false,
        values: []
      }
    };
  },

  [ACTION.REQUEST_PERSON_OPTIONS]: (state: AdministrationUserEditState, action: RequestPersonOptions): AdministrationUserEditState => {
    return {
      ...state,
      personOptionsCodes: {
        fetching: true,
        values: []
      }
    };
  },

  [ACTION.RECEIVE_PERSON_OPTIONS]: (state: AdministrationUserEditState, action: ReceivePersonOptions): AdministrationUserEditState => {
    return {
      ...state,
      personOptionsCodes: {
        fetching: false,
        values: action.values
      }
    };
  },

  [ACTION.FAIL_PERSON_OPTIONS]: (state: AdministrationUserEditState, action: FailPersonOptions): AdministrationUserEditState => {
    return {
      ...state,
      personOptionsCodes: {
        fetching: false,
        values: []
      }
    };
  },

  [ACTION.REQUEST_ROLE]: (state: AdministrationUserEditState, action: RequestRole): AdministrationUserEditState => {
    return {
      ...state,
      role: {
        id: action.id,
        fetching: true
      }
    };
  },

  [ACTION.RECEIVE_ROLE]: (state: AdministrationUserEditState, action: ReceiveRole): AdministrationUserEditState => {

    if (!state.role || (action.id !== undefined && action.id !== state.role.id)) {
      return state;
    }

    return {
      ...state,
      role: {
        id: action.id,
        fetching: false,
        data: action.data
      }
    };
  },

  [ACTION.FAIL_ROLE]: (state: AdministrationUserEditState, action: FailRole): AdministrationUserEditState => {

    if (!state.role || state.role.id !== action.id) {
      return state;
    }

    return {
      ...state,
      role: {
        id: action.id,
        fetching: false
      }
    };
  },

  [ACTION.UPDATE_ACCESS_DATA]: (state: AdministrationUserEditState, action: UpdateAccessData): AdministrationUserEditState => {

    const accessData = state.accessData || {};
    const accessItem = accessData[action.key] || {} as AccessItem;

    return {
      ...state,
      accessData: {
        ...accessData,
        [action.key]: {
          ...accessItem,
          ...action.accessItem
        }
      }
    };
  },
  [ACTION.REQUEST_ROLE_PANEL_ACCESS]: (state: AdministrationUserEditState, action: RequestRolePanelAccess): AdministrationUserEditState => {
    return {
      ...state,
      rolePanelAccess: false
    };
  },
  [ACTION.RECEIVE_ROLE_PANEL_ACCESS]: (state: AdministrationUserEditState, action: ReceiveRolePanelAccess): AdministrationUserEditState => {
    return {
      ...state,
      rolePanelAccess: !!action.values.length,
      allowedAccessBasedRoles: action.values
    };
  },
  [ACTION.FAIL_ROLE_PANEL_ACCESS]: (state: AdministrationUserEditState, action: FailRolePanelAccess): AdministrationUserEditState => {
    return {
      ...state,
      rolePanelAccess: false
    };
  },
  [ACTION.REQUEST_CHANGE_DATABASE_ACCOUNT]: (state: AdministrationUserEditState,
    action: RequestChangeDatabaseAccount): AdministrationUserEditState => {
    return {
      ...state,
      fetchingDatabaseAccount: true
    };
  },
  [ACTION.RECEIVE_CHANGE_DATABASE_ACCOUNT]: (state: AdministrationUserEditState,
    action: ReceiveChangeDatabaseAccount): AdministrationUserEditState => {
    return {
      ...state,
      fetchingDatabaseAccount: false
    };
  },
  [ACTION.FAIL_CHANGE_DATABASE_ACCOUNT]: (state: AdministrationUserEditState,
    action: FailChangeDatabaseAccount): AdministrationUserEditState => {
    return {
      ...state,
      fetchingDatabaseAccount: false
    };
  },

  [ACTION.PROCESS_USER_FAILED]: (state: AdministrationUserEditState, action: ProcessUserFailed): AdministrationUserEditState => {
    return {
      ...state,
      validation: action.validation
    };
  },

  [ACTION.CLEAR_VALIDATION]: (state: AdministrationUserEditState, action: ClearValidation): AdministrationUserEditState => {
    return {
      ...state,
      validation: clearValidation(state.validation, action.formName, action.parameters)
    };
  },

  [ACTION.UPDATE_VALIDATION]: (state: AdministrationUserEditState, action: UpdateValidation): AdministrationUserEditState => {
    return {
      ...state,
      validation: action.validation
    };
  },

  [ACTION.RESET_VALIDATION]: (state: AdministrationUserEditState, action: ResetValidation): AdministrationUserEditState => {
    const validation = { ...state.validation, [action.key]: undefined };

    return {
      ...state,
      validation
    };
  },

  [ACTION.REQUEST_DEFAULT_ROLE]: (state: AdministrationUserEditState, action: RequestDefaultRole): AdministrationUserEditState => {
    return {
      ...state,
      fetchingDefaultRole: true
    };
  },

  [ACTION.RECEIVE_DEFAULT_ROLE]: (state: AdministrationUserEditState, action: ReceiveDefaultRole): AdministrationUserEditState => {
    return {
      ...state,
      fetchingDefaultRole: false,
      defaultRole: action.defaultRole
    };
  },

  [ACTION.FAIL_DEFAULT_ROLE]: (state: AdministrationUserEditState, action: FailDefaultRole): AdministrationUserEditState => {
    return {
      ...state,
      fetchingDefaultRole: false
    };
  },

  [ACTION.SHOW_TECHNICAL_USER_WARNING]: (
    state: AdministrationUserEditState,
    action: ShowTechnicalUserWarning
  ): AdministrationUserEditState => {
    return {
      ...state,
      isTechnicalUserWarningShown: true
    };
  },

  [ACTION.HIDE_TECHNICAL_USER_WARNING]: (
    state: AdministrationUserEditState,
    action: HideTechnicalUserWarning
  ): AdministrationUserEditState => {
    return {
      ...state,
      isTechnicalUserWarningShown: false
    };
  },

  [ACTION.REQUEST_CHECK_ROLES]: (state: AdministrationUserEditState, action: RequestCheckRoles): AdministrationUserEditState => {

    return {
      ...state,
      fetchingRoles: true
    };
  },

  [ACTION.RECEIVE_CHECK_ROLES]: (state: AdministrationUserEditState, action: ReceiveCheckRoles): AdministrationUserEditState => {

    return {
      ...state,
      hasRoles: action.hasRoles,
      fetchingRoles: false
    };
  },

  [ACTION.FAIL_CHECK_ROLES]: (state: AdministrationUserEditState, action: FailCheckRoles): AdministrationUserEditState => {

    return {
      ...state,
      fetchingRoles: false
    };
  },

  [ACTION.UPDATE_MERGE_USER]: (state: AdministrationUserEditState, action: UpdateMergeUser): AdministrationUserEditState => {

    return {
      ...state,
      mergeUser: action.mergeUser
    };
  },

  [ACTION.REQUEST_USER_OPTIONS]: (state: AdministrationUserEditState, action: RequestUserOptions): AdministrationUserEditState => {
    return {
      ...state,
      userOptions: {
        fetching: true,
        values: []
      }
    };
  },

  [ACTION.RECEIVE_USER_OPTIONS]: (state: AdministrationUserEditState, action: ReceiveUserOptions): AdministrationUserEditState => {
    return {
      ...state,
      userOptions: {
        fetching: false,
        values: action.values
      }
    };
  },

  [ACTION.FAIL_USER_OPTIONS]: (state: AdministrationUserEditState, action: FailUserOptions): AdministrationUserEditState => {
    return {
      ...state,
      userOptions: {
        fetching: false,
        values: []
      }
    };
  },

  [ACTION.REQUEST_USER_ITEM_DELETE]: (state: AdministrationUserEditState, action: RequestUserItemDelete): AdministrationUserEditState => {
    return {
      ...state,
      mergeUser: {
        ...state.mergeUser,
        fetching: true
      }
    };
  },

  [ACTION.RECEIVE_USER_ITEM_DELETE]: (state: AdministrationUserEditState, action: ReceiveUserItemDelete): AdministrationUserEditState => {
    return {
      ...state,
      mergeUser: {
        ...state.mergeUser,
        fetching: false
      }
    };
  },

  [ACTION.FAIL_USER_ITEM_DELETE]: (state: AdministrationUserEditState, action: FailUserItemDelete): AdministrationUserEditState => {
    return {
      ...state,
      mergeUser: {
        ...state.mergeUser,
        fetching: false
      }
    };
  }
};

export const stateReducer: Reducer<AdministrationUserEditState> =
  (state: AdministrationUserEditState = INITIAL_ADMINISTRATION_STATE, action: any) => {
    const r = reducers[action.type];
    return (r && r(state, action)) || simpleFormReducer(STATE.administrationEdit)(state, action);
  };

export const reducer = withOptionsReducer(STATE.administrationEdit, stateReducer);
